import { render, staticRenderFns } from "./transactionNew.vue?vue&type=template&id=4b991e02&scoped=true&"
import script from "./transactionNew.vue?vue&type=script&lang=js&"
export * from "./transactionNew.vue?vue&type=script&lang=js&"
import style0 from "./transactionNew.vue?vue&type=style&index=0&id=4b991e02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b991e02",
  null
  
)

export default component.exports